/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information.
 *
 * The version of the OpenAPI document: 0.2.2
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GeoJson } from './GeoJson';
import {
    GeoJsonFromJSON,
    GeoJsonFromJSONTyped,
    GeoJsonToJSON,
} from './GeoJson';

/**
 * 
 * @export
 * @interface ShipSearchQuerystringGet200ResponseRecordsInner
 */
export interface ShipSearchQuerystringGet200ResponseRecordsInner {
    /**
     * 
     * @type {number}
     * @memberof ShipSearchQuerystringGet200ResponseRecordsInner
     */
    mmsi?: number;
    /**
     * 
     * @type {number}
     * @memberof ShipSearchQuerystringGet200ResponseRecordsInner
     */
    imo?: number;
    /**
     * 
     * @type {string}
     * @memberof ShipSearchQuerystringGet200ResponseRecordsInner
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipSearchQuerystringGet200ResponseRecordsInner
     */
    callsign?: string;
    /**
     * 
     * @type {GeoJson}
     * @memberof ShipSearchQuerystringGet200ResponseRecordsInner
     */
    position?: GeoJson;
}

/**
 * Check if a given object implements the ShipSearchQuerystringGet200ResponseRecordsInner interface.
 */
export function instanceOfShipSearchQuerystringGet200ResponseRecordsInner(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ShipSearchQuerystringGet200ResponseRecordsInnerFromJSON(json: any): ShipSearchQuerystringGet200ResponseRecordsInner {
    return ShipSearchQuerystringGet200ResponseRecordsInnerFromJSONTyped(json, false);
}

export function ShipSearchQuerystringGet200ResponseRecordsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShipSearchQuerystringGet200ResponseRecordsInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'mmsi': !exists(json, 'mmsi') ? undefined : json['mmsi'],
        'imo': !exists(json, 'imo') ? undefined : json['imo'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'callsign': !exists(json, 'callsign') ? undefined : json['callsign'],
        'position': !exists(json, 'position') ? undefined : GeoJsonFromJSON(json['position']),
    };
}

export function ShipSearchQuerystringGet200ResponseRecordsInnerToJSON(value?: ShipSearchQuerystringGet200ResponseRecordsInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'mmsi': value.mmsi,
        'imo': value.imo,
        'name': value.name,
        'callsign': value.callsign,
        'position': GeoJsonToJSON(value.position),
    };
}

